module.exports = __webpack_public_path__ + "img/(8).da57c976.jpg";